import { AnalyticsFilters } from '@app/types/analytics-filters';

export class LoadAnalytics {
  static readonly type = '[LoadAnalytics] Load Analytics dashboard';
  constructor(
    public payload?: {
      filters?: AnalyticsFilters;
      pageNumber?: number;
      pageSize?: number;
    },
  ) {}
}

export class ResetAnalytics {
  static readonly type = '[ResetAnalytics] Reset analytics dashboard';
}
